import {ApiCollection} from "./api.collection";
import {Action} from "../models/action.model";


export const Actions = ApiCollection.extend({
    model: Action,
    comparator: 'action_desc',
    url: 'api/actions',
});
